var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[(_vm.activeComponent)?_c(_vm.activeComponent,{tag:"component",on:{"createConnector":_vm.createConnector,"cancel":_vm.cancel}}):_c('h2',{staticClass:"dashboard mt-12"},[_vm._v(" В настоящее время настройки в этом источнике не поддерживается ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }